import { IXM_USERAUTH_V1_TENANT_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixm-userauth-v1-tenant-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxmUserauthV1TenantStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface TenantStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxmUserauthV1TenantStatus | undefined;
}

export function TenantStatusPill({ isPending, status, ...props }: TenantStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXM_USERAUTH_V1_TENANT_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixmUserauthV1', enumName: 'IxmUserauthV1TenantStatus', value: status }} />
    </Pill>
  );
}
